import axios from 'axios';
import { hpGqlClient } from 'root/api';
import { getFullName } from 'root/helpers';
import { IProfile } from 'root/models';
import { getFirebaseApp } from 'root/services';
import { IState } from 'root/store';
import { saveAs } from 'save-as';
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapState } from 'vuex';
import './styles.scss';

@Component({
  template: require('./view.html'),
  props: {
    contractStatus: Object
  },
  computed: {
    ...mapState({
      data: (state: IState) => state.profile.data[0]
    })
  },
  watch: {
    data(val) {
      if (!val) {
        return;
      }
      if (val.progress.contractSigned) {
        this.$props.contractStatus.signed = 2;
      }
      if (val.contractPdf) {
        this.$props.contractStatus.generated = true;
      }
    }
  }
})
export class ProfileContractViewer extends Vue {
  public data: IProfile;
  public loading: boolean = false;

  public mounted() {
    if (this.data && this.data.progress.contractSigned) {
      this.$props.contractStatus.signed = 2;
    }
    if (this.data && this.data.contractPdf) {
      this.$props.contractStatus.generated = true;
    }
  }

  public createContract() {
    this.loading = true;
    this.data.contractDocx = '';
    this.data.contractPdf = '';
    this.$props.contractStatus.generated = false;
    this.$message.success(this.$t('creating_contract').toString());
    hpGqlClient.user.generateContract(this.$route.params.id)
      .then((res) => {
        this.data.contractDocx = res.docx;
        this.data.contractPdf = res.pdf;
        this.$props.contractStatus.generated = true;
        this.$message.success(this.$t('candidate_contract_created_successfully').toString());
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        this.$message.error(this.$t('error_creating_contract').toString());
        this.loading = false;
      });
  }

  public async download(url: string) {
    const metadata = await getFirebaseApp().storage().refFromURL(url).getMetadata();
    axios({
      url,
      method: 'get',
      responseType: 'arraybuffer'
    })
    .then((response) => {
      saveAs(new Blob([response.data]), `${getFullName(this.data, '_')}_${metadata.name}`);
    })
    .catch(() => this.$message.error(this.$t('something_went_wrong').toString()));
  }
}
